import type { Theme } from '@mui/material'
import type { SystemStyleObject } from '@mui/system'

const selectedRing = (theme: Theme): string => `0 0 0 1px ${theme.palette.grey[200]}, ${theme.shadows[1]}`

/** The current page, as a white card on the navigation's grey background */
export const selectedNavigationItemStyle: SystemStyleObject<Theme> = {
    color: 'primary.700',
    backgroundColor: 'common.white',
    boxShadow: selectedRing,
    '&:hover': { backgroundColor: 'common.white' },
}
